module.exports = __webpack_public_path__ + "img/4.e61f3ad0.webp";